import React from 'react';
import get from 'lodash/get';
import { BLOCKS, MARKS } from '@contentful/rich-text-types';

export const customNodeRenderers = {
  [BLOCKS.EMBEDDED_ENTRY]: (node, next, key) => {
    const id = get(node, 'data.target.sys.contentType.sys.id', '');
    const fields = get(node, 'data.target.fields', {});

    switch(id){
    case 'black-headline':
      return fields.large_size ? (
        <h2 key={key} className="sub-heading">{fields.headline}</h2>
      ) : (
        <h3 key={key} className="sub-heading">{fields.headline}</h3>
      );
    case 'kallhnvisning':
      return <p key={key} className="text-small mt-2">{fields.text}</p>;
    default:
      return null;
    }
  },
  [BLOCKS.EMBEDDED_ASSET]: (node, next, key) => {
    const title = get(node, 'data.target.fields.title', '');
    const url = get(node, 'data.target.fields.file.url', '');

    return (
      <figure key={key}><img alt={title} src={url} /></figure>
    );
  }
}

export const customMarkRenderers = {
  [MARKS.BOLD]: (text, key) => (
    <span key={key} className="is-bold">{text}</span>
  ),
  [MARKS.ITALIC]: (text, key) => (
    <span key={key} className="is-italic">{text}</span>
  )
}

export const chunkOnEmptyParagraph = (richTextDocument) => {
  const content = richTextDocument.content;

  const chunks = [];
  let currentChunk = [];
  content.forEach((node, i) => {
    const isBreak = (
      node.nodeType === 'paragraph' &&
      node.content.length === 1 &&
      node.content[0].nodeType === 'text' &&
      node.content[0].value === ''
    );

    if (isBreak) {
      chunks.push(currentChunk);
      currentChunk = [];
    } else {
      currentChunk.push(node);
    }
  });

  if (currentChunk.length) {
    chunks.push(currentChunk);
  }

  return chunks.map(chunk => ({ nodeType: 'document', content: chunk, data: {}}));
}